module.exports = __webpack_public_path__ + "static/media/Futura-LT-Book.a22af61a.otf";